import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InstagramUserHashtagPostsSortOrder, Order } from '@anytag/graphql';
import { TagsAnalyticsSearchSchema } from '../../shared';

export const InstagramHashtagsAnalyticsSearchSchema = TagsAnalyticsSearchSchema.extend({
  sort: SearchSchema.types.sort(InstagramUserHashtagPostsSortOrder).default({
    order: Order.ASC,
    field: InstagramUserHashtagPostsSortOrder.RANK
  })
});
export type InstagramHashtagsAnalyticsSearchSchemaType = z.infer<typeof InstagramHashtagsAnalyticsSearchSchema>;
